export default {
  LOAD_EVENT_SESSION_FORM_PAGE_START: 'LoadGeneralCompetencyEventSessionFormPageStart',
  LOAD_EVENT_SESSION_FORM_PAGE_END: 'LoadGeneralCompetencyEventSessionFormPageEnd'
};
